<div class="alt-footer">
    <div class="row2">
        <div class="copyright col-md-6">{{pageFooterResponseJSON.copyrightMessage}}</div>
        <!-- <div class="col-md-6 text-right">
            <span class="appStoreIcons">
                        <a href="https://play.google.com/store/apps/details?id=com.peoplestrong.alt.organise" target="_blank"><img src="../../../assets/images/google-playstore.png">
                        </a>
                        </span>
            <span class="appStoreIcons">
                    <a href="http://apple.co/2gGFhBd" target="_blank"><img src="../../../assets/images/appstore.png"></a>
                    </span>
        </div> -->
    </div>
</div>